import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import URLS from "../../../../services/URLS";
import {
  CONNECT_BANK,
  CONNECT_BANK_DETAIL,
  DELETE_PAYMENT_METHODS,
  GET_PAYMENT_METHODS,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import Table from "../../../../components/Common/Table";
import ConfirmModel from "../../../../components/Modals/ConfirmModel";

const PaymentMethod = () => {
  const [payments, setPayments] = useState(null);
  const [deleteModelStatus, setDeleteModelStatus] = useState();
  let userId = localStorage.getItem("_id");
  const [dumpId, setDumpId] = useState();
  const getPayments = async () => {
    try {
      const res = await CONNECT_BANK_DETAIL(userId);

      if (res?.status === 200) {
        setPayments(res?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const deleteHandler = async () => {
    try {
      const res = await DELETE_PAYMENT_METHODS({
        accountId: dumpId,
      });
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setDumpId("");
        setDeleteModelStatus(false);
        getPayments();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getPayments();
  }, []);

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => <p className={` m-0`}>{key + 1}</p>,
    },
    {
      label: "Routing Number",
      id: "routing_number",
    },
    {
      label: "Account Number",
      id: "account",
    },
    {
      label: "Account Holder Name",
      id: "account_holder_name",
      isComponent: true,
      component: (item, key) => <p className={` m-0`}>{item?.account_holder_name ? item?.account_holder_name : payments?.business_profile?.name}</p>,
    },
    {
      label: "Bank Name",
      id: "bank_name",
    },

  ];

  const handleConnect = () => {
    const ele = document.createElement("a");
    ele.href = `${URLS.API_URL}api/v1/provider/stripe/connect?_id=${userId}`;
    ele.target = "_blank";
    ele.click();

  };


  return (
    <>
      <ConfirmModel
        modelStatus={deleteModelStatus}
        setModel={setDeleteModelStatus}
        confirmHandler={deleteHandler}
        type={"delete"}
      />
      <section className="manageDriver py-2 position-relative">
        <Container>
          {/* <Row className="justify-content-center">
            <Col lg="4" md="6" sm="8" className="my-2">
              <div className="cardCstm p-3 bg-white rounded pb-5">
                <div className="py-2 head mb-2">
                  <h4 className="m-0 themeBlue fw-sbold">Payment Method</h4>
                </div>
                <ul className="list-unstyled ps-0 mb-0 border-top">
                  <li className="py-2 border-bottom">
                    <p className="m-0 themeBlue">Routing Number:</p>
                    <p className="m-0 fw-sbold text-danger">5d4d5de74d5d4</p>
                  </li>
                  <li className="py-2 border-bottom">
                    <p className="m-0 themeBlue">Account Number:</p>
                    <p className="m-0 fw-sbold text-danger">2154 8754 5682</p>
                  </li>
                  <li className="py-2 border-bottom">
                    <p className="m-0 themeBlue">Account Holder Name:</p>
                    <p className="m-0 fw-sbold text-danger">Jason Moma</p>
                  </li>
                  <li className="py-2">
                    <p className="m-0 themeBlue">Bank Name:</p>
                    <p className="m-0 fw-sbold text-danger">Bank of america</p>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-3">
                <Link to="/setting/payment-method/add">
                  <Button
                    onClick={() => "2"}
                    className="d-inline-flex align-items-center justify-content-center commonBtn"
                  >
                    Add Bank Details
                  </Button>
                </Link>
              </div>
            </Col>
          </Row> */}
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Payment Methods</h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between gap-10 mb-3 mt-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10"></ul>
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <Button className="d-inline-flex align-items-center justify-content-center commonBtn"
                    onClick={handleConnect}
                  >
                    Add Bank Details
                  </Button>
                </div>
              </div>
              <div className="table-responsive">
                <Table data={payments?.external_accounts?.data} column={col} />

                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="left">
                    {/* <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                      <li>
                        <p className="m-0 fw-sbold themeBlue">
                          Total users: {totalCount}
                        </p>
                      </li>
                      <li>
                        <p className="m-0 fw-sbold themeBlue">
                          Active drivers: 9
                        </p>
                      </li>
                    </ul> */}
                  </div>
                  {/* <div className="right">
                    <CustomPagination
                      total={totalCount}
                      current={body.page}
                      pageSize={body.limit}
                      pageChangeHandler={pageChangeHandler}
                    />
                  </div> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PaymentMethod;
